/*
 * @Description: Description
 * @Author: Xiaohua Zhu
 * @Date: 2022-03-16 15:51:11
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-04-21 14:02:48
 */
import { cabinetType1 } from './const';

const {
  V, VI, VII, XIII, X, XI, XII, XXXIII, XXXIV, XXXV, XXXVI, XXXVII,
} = cabinetType1;
const drawerIdList = [V, VI, VII];// 抽屉
const highFrameIdList = [X, XI, XII, XXXIII, XXXIV, XXXV, XXXVI, XXXVII];// 高柜
const seasoningIdList = [XIII]; // 调料抽

const framePositionArr = ['top', 'bottom'];
const frameLengthArr = ['length1', 'length2', 'length3'];


/**
 * @description: 将mcc中的相关配件数量遍历出来储存到goodsList中
 * @param {*} temp:mcc对象
 * @return {*} goodsList
 * @author: Xiaohua Zhu
 */
const countGoodsNum = (temp) => {
  // goodList对象 记录每件配件的数量
  const goodsList = {
    drawerNum: 0, // 抽屉数量
    highFrameNum: 0, // 高柜数量
    seasoningNum: 0, // 调料抽数量
  };
  // 遍历顶柜底柜
  framePositionArr.forEach((position) => {
    // 遍历顶柜底柜每条边
    frameLengthArr.forEach((length) => {
      if (temp[position] && temp[position][length]) {
        // 遍历底柜顶柜每条边的frames
        temp[position][length].frames.forEach((element) => {
          if (element) {
            // 判断该frame是不是抽屉
            if (drawerIdList.includes(element.categoryId)) {
              goodsList.drawerNum += 1;
            // 判断该frame是不是高柜
            } else if (highFrameIdList.includes(element.categoryId)) {
              goodsList.highFrameNum += 1;
            // 判断该frame是不是调料抽
            } else if (seasoningIdList.includes(element.categoryId)) {
              goodsList.seasoningNum += 1;
            }
          }
        });
      }
    });
  });
  return goodsList;
};


/**
 * @description: 比较新旧两个mcc对象，将有减少的配件提取出来
 * @param {*} oldTemp
 * @param {*} newTemp
 * @return {*} reducedGoodsCounts:将有减少的配件提取出来保存到对象里，没有减少的储存为null
 * @author: Xiaohua Zhu
 */
export const getReducedGoods = ({ oldTemp, newTemp }) => {
  // 从新旧mcc中提取出各个配件的数量
  const oldTempGoodsCounts = countGoodsNum(oldTemp);
  const newTempGoodsCounts = countGoodsNum(newTemp);
  // 比较各个配件的数量 有减少就去减少后的新的值 没有减少（或都为0，新旧mcc都没有这个配件）就赋值null
  const reducedGoodsCounts = {
    drawerNum: newTempGoodsCounts.drawerNum < oldTempGoodsCounts.drawerNum ? newTempGoodsCounts.drawerNum : null,
    highFrameNum: newTempGoodsCounts.highFrameNum
     < oldTempGoodsCounts.highFrameNum ? newTempGoodsCounts.highFrameNum : null,
    seasoningNum: newTempGoodsCounts.seasoningNum
     < oldTempGoodsCounts.seasoningNum ? newTempGoodsCounts.seasoningNum : null,
  };
  return reducedGoodsCounts;
};

/**
 * @description: 将减少的配件的对象转成需要展示的文案
 * @param {*} reducedGoodsCounts
 * @param {*} t
 * @return {*} tipsInfoArr:{name:提示信息名,text:提示信息文案 }
 * @author: Xiaohua Zhu
 */
export const getReduceGoodsTipsAfterChangeSize = (reducedGoodsCounts, t) => {
  const tipsInfoArr = [];
  // 解构出配件
  const { drawerNum, highFrameNum, seasoningNum } = reducedGoodsCounts;
  // 不为null则新mcc内该配件有减少 需要加入提示信息数组
  if (drawerNum !== null) {
    const tipsInfo = { name: 'reduceDrawer' };
    // 如果xx配件减少后的数量为0 则使用‘不安装xx’文案
    if (drawerNum === 0) {
      tipsInfo.text = t('change_size.none_of_drawer_groups');
    // 不为0 则使用‘xx数量减少到x组（个）’文案
    } else {
      tipsInfo.text = t('change_size.reduce_the_number_of_drawer_groups', { num: drawerNum });
    }
    // 传入 提示信息数组 使组件可以遍历渲染提示文案
    tipsInfoArr.push(tipsInfo);
  }
  if (highFrameNum !== null) {
    const tipsInfo = { name: 'reduceHighFrame' };
    if (highFrameNum === 0) {
      tipsInfo.text = t('change_size.none_of_high_cabinet');
    } else {
      tipsInfo.text = t('reduce_the_number_of_high_cabinet', { num: highFrameNum });
    }
    tipsInfoArr.push(tipsInfo);
  }
  if (seasoningNum !== null) {
    const tipsInfo = { name: 'reduceSeasoning' };
    if (seasoningNum === 0) {
      tipsInfo.text = t('change_size.none_of_seasoning');
    } else {
      tipsInfo.text = t('change_size.reduce_the_number_of_seasoning', { num: seasoningNum });
    }
    tipsInfoArr.push(tipsInfo);
  }
  return tipsInfoArr;
};
